import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";

import * as types from "../../constants/ComponentConstants";
import BovenlokaliteitInfoPageHelper from "./BovenlokaliteitInfoPageHelper";
import * as infrastructuurActions from "../../actions/infrastructuurActions";


class BovenlokaliteitInfoPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.pageHelper = new BovenlokaliteitInfoPageHelper(this);
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillMount() {
		this.pageHelper.init();
		this.props.loadInfrastructurenByDossierId(this.props.dossierId);
	}

	render() {
		return (
			<Section title="Bovenlokaliteit" color={types.COLOR_PURPLE}>
				<Fieldset>
					In dit tabblad stellen we vragen om de “bovenlokaliteit” van jouw project te bepalen.
					<br /> <br />
					Aan de linkerzijde vind je voor elke infrastructuur waarvoor subsidies wordt gevraagd een knop om gegevens in te vullen m.b.t. het ruimtegebruik, de impact op het landschap, de topsportgelegenheid en de slaapgelegenheid.
					<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
				</Fieldset>
			</Section >
		);
	}
}

BovenlokaliteitInfoPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;

	return {
		dossierId: dossierId
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(BovenlokaliteitInfoPage));